<template>
  <div class="container-fluid align-center" role="region" aria-busy="true">
    <div class="row row-vertical-align-center">
      <div class="col align-center">
        <al-loader
          :done-loading="waitingForLoaderSuccessAnimation"
          class="margin-bottom-md"
          name="loading-indicator"
          @animationEnd="onAnimationEnd" />
        <h1 v-if="activeLoader.heading" class="heading-lg" data-test="loading-heading">
          {{ $t(activeLoader.heading) }}
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
import { AlLoader } from '@mc-alberta/alcapone'
import { mapActions, mapGetters } from 'vuex'
import { ROUTES } from '@/constants'

export default {
  name: ROUTES.PROCESSING,
  components: { AlLoader },
  computed: {
    ...mapGetters(['activeLoader', 'waitingForLoaderSuccessAnimation'])
  },
  methods: {
    ...mapActions(['stopLoader']),
    onAnimationEnd() {
      this.$root.$emit('processingEnd')
      this.stopLoader(this.activeLoader)
    }
  }
}
</script>
